/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { POTENCIA_MINIMA_VERTICAL, PROPOSTA_OPTIONS, SIMULTANEIDADE_MAX, SIMULTANEIDADE_MIN, NOVO_PROJETO_ENGENHARIA } from "src/components/projetos/constants";
import { ModalSimulacaoFinanciamento } from "src/components/projetos/containers/ModalSimulacaoFinanciamento";
import { OpcaoServicoSuspensa } from "src/components/projetos/containers/OpcaoServicoSuspensa";
import { ResumoProjeto, ResumoProjetoRow } from "src/components/projetos/containers/ResumoProjeto";
import { ComponenteCalcular, Projeto, ProjetoCalcular, ResultadoCalculos } from "src/components/projetos/types";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { IDataResponse } from "src/framework/providers/api";
import { HspProvider } from "src/providers/cadastros/HspProvider";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { setDimensionadoTabDoneStatus, setRoiPaybackModalStatus, setServicoInformationModalStatus } from "src/store/vendas/projetos/actions";
import { formatarComponentesCalcular } from "src/components/projetos/utils/formatarComponentesCalcular";
import theme from "src/theme/light";
import { InputsSection } from "src/components/projetos/containers/InputsSection";
import { LayoutProjetoDimensionado } from "../../_layouts";
import { Info } from "@mui/icons-material";
import { GraficosRoiPayback } from "src/components/projetos/containers/GraficosRoiPayback";
import makeStyles from '@mui/styles/makeStyles';
import { redirecionarParaEngenharia } from "src/components/projetos/utils/redirecionarParaEngenharia";
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { alterandoServico$, calculoProjetoRealizado$, exibeJustificativaValorServico$, formState$ } from "src/store/vendas/projetos/store"
import { useHistory } from "react-router-dom"
import {PaybackSemConsiderarInstalacao} from "../../../containers/PaybackSemConsiderarInstalacao";
import { validacaoValorServicoMinimo } from "src/components/projetos/utils/validarValorServicoMinimo";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { mostrarAvisoServicoRemovido } from "src/components/projetos/utils/mostrarAvisoServicoRemovido";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ID_MICROINVERSOR } from "src/components/componentes/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { useObservable } from "src/framework/store/storeUtil";

interface ValorTotalProps {
  formState: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
  onClickNext: () => void;
  onClickBack: () => void;
}

const projetosProvider = new ProjetosProvider()
const hspProvider = new HspProvider()

let timerCalcular: NodeJS.Timeout

const useStyles = makeStyles({
  boxInfo: {
    borderRadius: 8, 
    backgroundColor:'#61616121', 
    borderLeft: "10px solid #8BE68A",
    paddingLeft: 25 
  }
});


function ValorTotal({ formState, onChangeFormState, onClickBack, onClickNext }: ValorTotalProps) {
  const permissoes = PermissionUtil.getPermissions();
  const [simulacaoModalIsOpened, setSimulacaoModalIsOpened] = useState(false)
  const [calculando, setCalculando] = useState(false)

  const calculoProjetoRealizado = useObservable(calculoProjetoRealizado$);
  const alterandoServico = useObservable(alterandoServico$);

  const [valorMinimoServico, setValorMinimoServico] = useState(0)
  const classes = useStyles();
  const history = useHistory();
  const [hspMedio, setHspMedio] = useState(0)
  const [textoTooltipDisabled, setTextoTooltipDisabled] = useState<string>("Para salvar o projeto é necessário aceitar os termos do projeto.");

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const setFormState = useCallback((newState: Partial<Projeto>) => {
    onChangeFormState(old => ({...old, ...newState}))
  },[onChangeFormState])

  useEffect(()=>{
    if ((formState.isEdit || formState.clonar_projeto) && Number(formState.valor_servico || 0) > 0 && !formState?.revenda?.segmentos_servico?.includes(formState?.segmento?.includes("on") ? "on" : "off")) {
      setFormState({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        codigo_servico: "",
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao')
      })
      
      mostrarAvisoServicoRemovido()
    }
  },[])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;

    return DecimalUtil.toFixed((potencia * quantidade) / 1000, 2)
  },[formState?.modulosList]);

  useEffect(()=>{
    if (servicoObrigatorio && (formState?.valor_servico || 0) > 0 && valorMinimoServico > 0 && !validacaoValorServicoMinimo(formState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      notifierStore.setNotifier({
        title: 'Atenção!',
        content: [
          'O valor do serviço não atende às exigências vigentes.',
          'Por favor, atualize conforme as instruções fornecidas abaixo do campo "Valor do Serviço Líquido”.'
        ],
        timeOut: 4000,
        onClose: () => notifierStore.setOpen(false),
      });
      notifierStore.setOpen(true);
    }
  },[valorMinimoServico, potenciaTotal])

  const potenciaVertical = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_VERTICAL
  },[potenciaTotal]);

  const servicoObrigatorio = useMemo(()=>{
    if (potenciaVertical) return false;

    return formState.tipo_proposta?.value === 'gerador-com-instalacao'
  },[formState.tipo_proposta?.value, formState?.modulosList, potenciaVertical])

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && formState.recebe_servico) 
  },[servicoObrigatorio, formState.recebe_servico])

  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;
    
    if (!formState?.valor_servico) return false;
    if (!valorMinimoServico) return false;

    const valorServicoProjeto = Number(formState?.valor_servico || 0)
    return valorServicoProjeto < Number(valorMinimoServico || 0);
  },[formState?.valor_servico, mostrarCampoValorServico, valorMinimoServico])

  useEffect(()=>{
    exibeJustificativaValorServico$.next(exibirJustificativaValorServico)
  },[exibirJustificativaValorServico])

  const nextButtonIsDisabled = useMemo(() => {
    if (servicoObrigatorio && !formState.valor_servico) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (servicoObrigatorio && formState.valor_servico && Number(formState.valor_servico) === 0) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (!formState.valor_anual_manutencao) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário estar preenchido o custo anual com manutenção.");
      return true;
    }

    if (servicoObrigatorio && (formState?.valor_servico || 0) > 0 && !validacaoValorServicoMinimo(formState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir o valor mínimo do serviço`);
      return true;
    }

    if (exibirJustificativaValorServico && !(formState?.justificativa_valor_servico || "")) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir a justificativa do valor de serviço`);
      return true;
    }

    const inversores = formState?.inversoresList || [];
    const temMicroInversorNoProjeto = inversores.some(item => {
      return item.categoria_componentes_id === ID_MICROINVERSOR && item.quantidade > 0
    });

    if (formState?.tipo_inversor?.value === ID_MICROINVERSOR && !temMicroInversorNoProjeto) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir pelo menos um microinversor.`);
      return true;
    }

    if (!calculoProjetoRealizado) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário realizar o cálculo dos valores do projeto.`);
      return true;
    }

    if (alterandoServico || calculando) {
      setTextoTooltipDisabled(`Aguarde o calculo finalizar para prosseguir.`);
      return true;
    }

    return false;
  },[formState?.tipo_inversor, formState?.inversoresList, exibirJustificativaValorServico, formState?.valor_servico, formState?.justificativa_valor_servico, valorMinimoServico, formState.termo_aceito, formState.valor_anual_manutencao, formState.valor_servico, servicoObrigatorio, calculoProjetoRealizado, alterandoServico, calculando])

  useEffect(()=>{
    setDimensionadoTabDoneStatus('valor_total', !nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  useEffect(() => {
    if (formState.latitude && formState.longitude) {
      hspProvider.calcular(formState.latitude, formState.longitude).then((hsp)=>{
        setHspMedio(hsp?.hsp_medio || 0)
      })
    }
  },[formState.latitude, formState.longitude])

  useEffect(()=>{
    if (potenciaTotal > 0) {
      projetosProvider.calcularValorMinimoServico(potenciaTotal || 0).then((response) => {
        setValorMinimoServico(response.data?.valor_minimo_servico || 0)
      })
    }
  },[potenciaTotal])

  const resumoProjeto = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Título', value: formState.titulo || '' },
      { label: 'HSP médio', value: hspMedio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
      { label: 'Potência do gerador (kWp)', value: `${(formState.resultado_calculos?.componentes?.potencia_gerador || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (kWp)` },
      { label: 'Peso do gerador (Kg)', value: `${(formState.resultado_calculos?.componentes?.peso_gerador || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (Kg)` },
      { label: 'Peso do gerador no telhado (Kg)', value: `${(formState.resultado_calculos?.componentes?.peso_telhado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (Kg)` }
    ]
  }, [hspMedio, formState.titulo, formState.resultado_calculos])

  const valoresCalculos = useMemo((): { total: number; totalComponentes: number; totalServico: number; } =>{
    const totalComponentes = Number(formState.resultado_calculos?.componentes?.valor || 0)
    const totalServico = Number(formState.resultado_calculos?.servicos?.valor_com_pis_cofins || 0)
    return {total: totalServico + totalComponentes, totalComponentes, totalServico }
  },[formState.resultado_calculos?.componentes?.valor, formState.resultado_calculos?.servicos?.valor_com_pis_cofins])

  const secaoValores = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Valor dos produtos', value: Formater.toString(valoresCalculos.totalComponentes, TypeRecords.CURRENCY) },
      { label: (
        <Box display="flex" alignItems={isMobile ? "end" : "center"}>
          <Typography style={{ display: 'block', textAlign: 'start' }} variant='subtitle1'>Valor do serviço da revenda com PIS/COFINS</Typography>
          <Box onClick={() => setServicoInformationModalStatus(true)} component={'button'} style={{ background: 'none', cursor: 'pointer' }} border={"none"}>
            <Info color="primary" fontSize={"small"} />
          </Box>
        </Box>
      ),
        value: Formater.toString(valoresCalculos.totalServico || 0, TypeRecords.CURRENCY),
        hide: Number(valoresCalculos.totalServico || 0) === 0,
      },
      { label: 'Valor total', value: <strong style={{ color: theme.palette.primary.main }}>{Formater.toString(valoresCalculos.total, TypeRecords.CURRENCY)}</strong> }
    ]
  },[valoresCalculos])

  const componentes = useMemo(()=>{
    const componentes: ComponenteCalcular[] = []
    
    const moduloSelecionado = formState.modulosList?.filter(item => item.selecionado)
    const inversoresAdicionados = formState.inversoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
    const estruturasAdicionadas = formState.estrutura_calculadas?.filter(item => Number(item.quantidade || 0) > 0) || []
    const acessoriosAdicionados = formState.acessorios?.filter(item => Number(item.quantidade || 0) > 0) || []

    if (moduloSelecionado?.length) {
      componentes.push(...formatarComponentesCalcular(moduloSelecionado))
    }

    if (inversoresAdicionados.length) {
      componentes.push(...formatarComponentesCalcular(inversoresAdicionados))
    }

    if (estruturasAdicionadas.length) {
      componentes.push(...formatarComponentesCalcular(estruturasAdicionadas))
    }

    if (acessoriosAdicionados.length) {
      componentes.push(...formatarComponentesCalcular(acessoriosAdicionados))
    }

    return componentes
  },[formState.modulosList, formState.inversoresList, formState.estrutura_calculadas, formState.acessorios])

  const calcular = useCallback(async()=>{
    const regioesIds = formState.regioes.map(item => item.id)

    const getValorServico = () => {
      if (!formState.recebe_servico) return 0;
      if (formState.tipo_proposta?.value === 'gerador-sem-instalacao') return 0;
      if (potenciaVertical) return 0;
      return Number(formState.valor_servico || 0)
    }

    const recalcular = projetosProvider.confereRecalcular(componentes, formState);

    const payload: ProjetoCalcular = {
      componentes,
      estado_id: formState.estado?.id || '',
      servicos: {
        valor_margem_produtos: 0,
        tipo: getValorServico() ? 'revenda' : null,
        valor: getValorServico(),
      },
      regioes: regioesIds,
      segmento: formState.segmento,
      projeto_id: formState.clonar_projeto ? undefined : (formState.id || undefined),
      distribuidor_id: formState.distribuidor?.id || undefined,
      revenda_id: formState.revenda?.id || undefined,
      recalcular: recalcular,
    }

    const responseCalcular: IDataResponse<ResultadoCalculos> = await projetosProvider.calcular(payload)

    setFormState({ valor_servico_pis_cofins: responseCalcular?.data?.servicos?.valor_com_pis_cofins || 0, resultado_calculos: responseCalcular.data })
  },[formState.regioes, formState.estado?.id, formState.tipo, formState.id, formState.distribuidor?.id, formState.revenda?.id, formState.recebe_servico, formState.tipo_proposta?.value, formState.valor_servico, componentes, setFormState])

  useEffect(()=>{
    clearTimeout(timerCalcular)
    setCalculando(true)
    timerCalcular = setTimeout(()=>{
      calcular().finally(() => setCalculando(false))
    }, 300)
  }, [calcular])

  useEffect(()=>{
    if (formState.recebe_servico === false || !formState.revenda) {
      const opt = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null
      onChangeFormState({ ...formState, tipo_proposta: opt })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[formState.recebe_servico, onChangeFormState, formState.revenda])

  useEffect(() => {
    if (potenciaVertical && Number(formState?.valor_servico) > 0) {
      redirecionarParaEngenharia({
        onNegation: () => {
          formState$.next({
            ...resetarProjeto(formState), 
            ...NOVO_PROJETO_ENGENHARIA,
            servico: formState?.servico,
            valor_servico: formState?.valor_servico, 
            id: 0,
          })
          history.push('/projetos/verticais/novo',{ allowAccess: true })
        },
        onConfirmation: () => {
          setFormState({ valor_servico: 0, servico: null })
        },
      });
    }
  },[potenciaVertical, formState?.valor_servico, setFormState])

  const showRoiPaybackButton = useMemo(()=>{
    if (!formState.estado) return false;
    if (!formState.tarifa_concessionaria_id) return false;
    if (formState.modo_calculo === "potencia") return false;
    if (!formState.fator_perdas) return false;
    if (!formState.latitude || !formState.longitude) return false;
    if (!formState.modulosList?.length) return false;
    if (!formState.potencia_desejada) return false;
    if (!formState.simultaneidade) return false;
    if (!valoresCalculos.total) return false;
    if (Number(formState.simultaneidade || 0) > SIMULTANEIDADE_MAX) return false;
    if (Number(formState.simultaneidade || 0) < SIMULTANEIDADE_MIN) return false;
    return true;
  },[formState, valoresCalculos])

  const handleOpenRoiPaybackModal = useCallback(()=>{
    const modulo = formState.modulosList?.find(modulo => modulo.selecionado)
    const potenciaGeradorEmKw = (Number(modulo?.potencia || 0) * Number(modulo?.quantidade || 0)) / 1000
    const recalcular = projetosProvider.confereRecalcular(componentes, formState);

    if (!showRoiPaybackButton) return;

    setRoiPaybackModalStatus(true, {
      calculateData: {
        consumos: formState.modo_calculo === 'consumo' ? formState.consumo_meses.map(item => ({ dia: item.day, consumo: item.value })) : [],
        fatorPerdas: formState.fator_perdas,
        latitude: formState.latitude,
        longitude: formState.longitude,
        moduloId: modulo?.componente_id || 0,
        potenciaGerador: potenciaGeradorEmKw,
        simultaneidade: Number(formState.simultaneidade || 0),
        valorProjeto: valoresCalculos.total,
        estadoId: formState.estado?.id || "",
        tarifaConcessionariaId: formState.tarifa_concessionaria_id || 0,
        dataProjeto: formState.created_at || new Date(),
        recalcular,
        idProjeto: formState.id || undefined,
      }
    })
  },[valoresCalculos, formState, showRoiPaybackButton])

  return (
    <>
      <LayoutProjetoDimensionado
        showRoiPaybackButton={showRoiPaybackButton}
        onClickRoiPaybackButton={handleOpenRoiPaybackModal}
        formState={formState}
        nextButtonLabel='Finalizar projeto'
        mostrarPremissas={false}
        onClickBack={onClickBack}
        nextButtonIsDisabled={nextButtonIsDisabled}
        onClickNext={onClickNext}
        title="Valor do Serviço"
        subtitle="Escolha o tipo de faturamento, simule o financiamento e gere gráficos de retorno ao seu cliente!"
        nextButtonDisabledTooltip={textoTooltipDisabled}
      >
        <Box p={2}>

          <Box marginBottom={2}>
            <InputsSection
              formState={formState}
              setFormState={setFormState}
              mostrarCampoValorServico={mostrarCampoValorServico}
              servicoObrigatorio={servicoObrigatorio}
              valorMinimoServico={(formState.valor_servico || 0) > 0 ? valorMinimoServico > 0 && validacaoValorServicoMinimo((formState.valor_servico || 0), valorMinimoServico, permissoes) ? 0 : valorMinimoServico : 0}
              exibirJustificativaValorServico={exibirJustificativaValorServico}
            />
          </Box>
            
          {!formState.recebe_servico && (
            <Box marginBottom={2}>
              <OpcaoServicoSuspensa />
            </Box>
          )}

          {potenciaTotal > POTENCIA_MINIMA_VERTICAL && (
            <Box marginBottom={2}>
              <Box width='100%' display='flex' py={2} className={classes.boxInfo}>
                <b>Atenção</b>: {`Serviço disponível para projetos até ${POTENCIA_MINIMA_VERTICAL} kWp`}
              </Box>
            </Box>
          )}

            {showRoiPaybackButton && formState.tipo_proposta?.value === "gerador-sem-instalacao" && (
              <Box marginBottom={2}>
                <PaybackSemConsiderarInstalacao />
              </Box>
            )}


          <Box marginBottom={2}>
            <ResumoProjeto
              formState={formState}
              simularFuncionamentoClick={() => setSimulacaoModalIsOpened(true)}
              valores={secaoValores}
              resumoProjeto={resumoProjeto}
            />
          </Box>
        </Box>
      </LayoutProjetoDimensionado>
      {simulacaoModalIsOpened && <ModalSimulacaoFinanciamento
        onChangeFormState={(newState:Partial<Projeto>) => {
          setFormState(newState)
        }}
        open={simulacaoModalIsOpened}
        formState={formState}
        onClose={() => setSimulacaoModalIsOpened(false)}
        valorTotal={valoresCalculos.total}
      />}
      <GraficosRoiPayback 
        valor_servico={formState?.valor_servico || 0}
      />
    </>
  )
}
export { ValorTotal }